/**
 * Private modules
 */
const {
  createQueryComponent,
  customerId,
  nickname,
  objectIds,
  reason,
  systemGameId,
  username,
} = require('../.private').components;

/**
 * Scopes
 */
const { DEFAULT } = require('../../scopes');

module.exports = {
  createCustomerPartners: {
    properties: {
      body: {
        properties: {
          nickname,
          username,
        },
        required: [
          'nickname',
          'username',
        ],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
        },
        required: ['customerId'],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  getCustomerPartnersBySystemGameId: {
    properties: {
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
      query: createQueryComponent([DEFAULT]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  recoverCustomerPartnersBySystemGameId: {
    properties: {
      body: {
        properties: {
          objectIds,
          reason,
        },
        required: [
          'objectIds',
          'reason',
        ],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
  removeCustomerPartnersBySystemGameId: {
    properties: {
      body: {
        properties: {
          objectIds,
          reason,
        },
        required: [
          'objectIds',
          'reason',
        ],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
};
